/**
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2024-12-19 09:59:56
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2024-12-23 10:51:46
 * @FilePath: src/api/file.js
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */
import request from '@/utils/request'

/**
 * 上传文件
 * @param {*} data 上传文件数据
 * @param {Function} onProgress 进度回调 (percent: 0-100)
 * @returns
 */
export function requestUploadFile(data, onProgress) {
  return request({
    url: '/base/file/uploadFile',
    method: 'POST',
    data,
    onUploadProgress: onProgress
      ? (progressEvent) => {
        const percent = Math.round(
          (progressEvent.loaded / progressEvent.total) * 100
        )
        onProgress(percent)
      }
      : undefined
  })
}
